export const PAGE_ASSETS = {
  general: 'general',
  totals: 'totals',
  apps: 'apps',
  monetization: 'monetization',
  timeSeries: 'time_series',
  sdks: 'sdks',
  company: 'company',
};

export const PERIOD_DEPENDENT_ASSETS = [
  PAGE_ASSETS.totals,
  PAGE_ASSETS.apps,
  PAGE_ASSETS.monetization,
  PAGE_ASSETS.timeSeries,
  PAGE_ASSETS.sdks,
  PAGE_ASSETS.company,
];

export const URL_SYNCED_PARAMS = [
  'period',
  'period_from_date',
  'period_to_date',
  'metric',
  'order',
  'offset',
];

export const DEFAULT_APPS_FILTERS = {
  metric: 'downloads',
  order: 'desc',
  offset: 0,
  limit: 10,
};

export const MAX_SHOWED_PERIOD = 365;

export const STORE_LABELS = {
  both: 'Both Stores',
  itunes_connect: 'iOS',
  google_play: 'Google Play',
};

export const STORE_ICONS = {
  both: 'hicon-unified',
  unified: 'hicon-unified',
  itunes_connect: 'hicon-apple',
  google_play: 'hicon-play',
};
